if (!customElements.get('bvg-review-rotation')) {
  customElements.define('bvg-review-rotation', class extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      this.index = 0;
      this.busy = false;
      this.cards = [...this.querySelectorAll('.bvg-reviews__card')];
      this.faces = this.cards.map(card => [...card.querySelectorAll('.bvg-reviews__face')]);
      this.total = Math.max(0, ...this.faces.map(faces => faces.length));
      if (!this.total) return;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      const pauseButton = this.querySelector('[data-pause]');
      const updatePause = () => { pauseButton.textContent = this.paused ? 'Play rotation' : 'Pause rotation'; };
      this.show = () => {
        this.faces.forEach(faces => faces.forEach((face, i) => { face.hidden = i !== this.index % faces.length; }));
        this.querySelector('[data-status]').textContent = (this.index + 1) + ' / ' + this.total;
      };
      this.show();
      this.dataset.ready = '';
      this.querySelector('.bvg-reviews__controls').hidden = this.total < 2;
      const change = async direction => {
        if (this.busy || this.total < 2) return;
        this.busy = true;
        this.index = (this.index + direction + this.total) % this.total;
        const animate = !this.motion.matches && this.cards.every(card => typeof card.animate === 'function');
        try {
          await Promise.all(this.cards.map(async (card, c) => {
            const faces = this.faces[c];
            if (!faces.length) return;
            let outgoing;
            let incoming;
            try {
              if (animate) {
                outgoing = card.animate(
                  [{transform:'translate3d(0,0,0) rotateY(0deg)',opacity:1},
                   {transform:'translate3d(' + (-direction * 14) + 'px,-5px,0) rotateY(' + (direction * 35) + 'deg)',opacity:0}],
                  {duration:460,delay:c*90,easing:'cubic-bezier(.4,0,1,1)',fill:'forwards'}
                );
                await outgoing.finished;
              }
              faces.forEach((face, i) => { face.hidden = i !== this.index % faces.length; });
              if (animate) {
                incoming = card.animate(
                  [{transform:'translate3d(' + (direction * 14) + 'px,-5px,0) rotateY(' + (-direction * 35) + 'deg)',opacity:0},
                   {transform:'translate3d(0,0,0) rotateY(0deg)',opacity:1}],
                  {duration:680,easing:'cubic-bezier(.16,1,.3,1)',fill:'forwards'}
                );
                outgoing.cancel();
                await incoming.finished;
              }
            } finally {
              outgoing?.cancel();
              incoming?.cancel();
            }
          }));
        } finally { this.show(); this.busy = false; }
      };
      this.querySelector('[data-next]').addEventListener('click', () => { this.paused = true; updatePause(); change(1); }, options);
      this.querySelector('[data-previous]').addEventListener('click', () => { this.paused = true; updatePause(); change(-1); }, options);
      pauseButton.addEventListener('click', () => { this.paused = !this.paused; updatePause(); }, options);
      this.addEventListener('mouseenter', () => {this.hovering = true;}, options);
      this.addEventListener('mouseleave', () => {this.hovering = false;}, options);
      this.addEventListener('focusin', event => { if(event.target !== pauseButton) { this.paused = true; updatePause(); } }, options);
      this.motion.addEventListener('change', () => {this.paused = this.motion.matches; updatePause();}, options);
      this.addEventListener('shopify:block:select', event => {
        this.paused = true; updatePause();
        const selected = this.faces.flat().find(face => face.contains(event.target) || face === event.target);
        if(selected) {this.index = this.faces.find(faces => faces.includes(selected)).indexOf(selected);this.show();}
      }, options);
      updatePause();
      this.timer = setInterval(() => {
        const box = this.getBoundingClientRect();
        if(!this.paused && !this.hovering && !document.hidden && box.bottom > 0 && box.top < innerHeight) change(1);
      }, 10000);
      this.cleanup = () => {clearInterval(this.timer);this.controller.abort();this.cards.forEach(card=>card.getAnimations().forEach(a=>a.finish()));};
    }
    disconnectedCallback() {this.cleanup?.();this.cleanup = null;}
  });
}
